import { useEffect, useRef, useState } from "react";

export default function useGuestNotifications(slug) {
  const [permission, setPermission] = useState(() => (typeof Notification !== "undefined" ? Notification.permission : "denied"));
  const sinceRef = useRef(new Date().toISOString()); // start from now — ignore historical
  const seenRef = useRef(new Set());

  const requestPermission = async () => {
    if (typeof Notification === "undefined") return "denied";
    try {
      const p = await Notification.requestPermission();
      setPermission(p);
      return p;
    } catch { return "denied"; }
  };

  useEffect(() => {
    if (!slug) return;
    let alive = true;
    const poll = async () => {
      try {
        const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/public/menu/${slug}/notifications?since=${encodeURIComponent(sinceRef.current)}`);
        const data = await res.json();
        if (!alive || !data.notifications) return;
        for (const n of data.notifications) {
          if (seenRef.current.has(n.id)) continue;
          seenRef.current.add(n.id);
          sinceRef.current = n.ts;
          try {
            if (typeof Notification !== "undefined" && Notification.permission === "granted") {
              const ntf = new Notification(`🍴 ${n.restaurant_name}`, { body: `${n.title}${n.body ? "\n" + n.body : ""}`, tag: n.id });
              ntf.onclick = () => { window.focus(); ntf.close(); };
            }
          } catch {}
          // Always emit an event so UI can also show toast in-app
          window.dispatchEvent(new CustomEvent("vm:notification", { detail: n }));
        }
      } catch {}
    };
    poll();
    const t = setInterval(poll, 5000);
    return () => { alive = false; clearInterval(t); };
  }, [slug]);

  return { permission, requestPermission };
}
